"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = _interopRequireDefault(require("lodash.debounce"));
var _glide = _interopRequireDefault(require("@glidejs/glide"));
var _excluded = ["carouselGlideElement", "responsive"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var _default = function _default(_ref) {
  var carouselGlideElement = _ref.carouselGlideElement,
    _ref$responsive = _ref.responsive,
    responsive = _ref$responsive === void 0 ? [] : _ref$responsive,
    options = _objectWithoutProperties(_ref, _excluded);
  var slides = carouselGlideElement.querySelectorAll('.glide__slides > li');
  var carouselLoop = carouselGlideElement.getAttribute('data-carousel-loop');
  var MOBILE_BREAKPOINT = 1024;
  var glide;
  var glideType4 = slides.length <= 4 ? 'slider' : 'carousel';
  var glideType2 = slides.length <= 2 ? 'slider' : 'carousel';
  // eslint-disable-next-line no-unneeded-ternary
  var isSwipe4 = slides.length <= 4 ? false : true;
  // eslint-disable-next-line no-unneeded-ternary
  var isSwipe2 = slides.length <= 2 ? false : true;
  var breakpointSettings = _objectSpread({
    500: {
      perView: 1,
      peek: {
        before: 40,
        after: 30
      }
    },
    900: {
      perView: 2,
      type: glideType2,
      swipeThreshold: isSwipe2,
      dragThreshold: isSwipe2
    },
    1200: {
      perView: 4,
      type: glideType4,
      swipeThreshold: isSwipe4,
      dragThreshold: isSwipe4
    }
  }, responsive);
  var getCurrentSettings = function getCurrentSettings() {
    var screenWidth = window.innerWidth;

    // Because the `perView` changes at different breakpoints, find
    // the relevant setting for the current screensize.
    // Filter out any settings that are smaller than the current size, and
    // then use the first in the list, as this will be the most relevant.
    // If none are available, assume we are using the biggest setting.

    // TODO: We should be able to reuse this, if we want to change the pagination
    // to scroll full pages, rather than individual items
    var breakpointSettingsForCurrentSize = Object.keys(breakpointSettings).filter(function (i) {
      return parseInt(i, 10) > screenWidth;
    })[0] || Object.keys(breakpointSettings).slice(-1);
    return breakpointSettings[breakpointSettingsForCurrentSize];
  };
  var enablePrevButton = function enablePrevButton() {
    carouselGlideElement.querySelector('.carousel__prev').classList.remove('disabled');
    carouselGlideElement.querySelector('.carousel__prev').removeAttribute('disabled');
  };
  var enableNextButton = function enableNextButton() {
    carouselGlideElement.querySelector('.carousel__next').classList.remove('disabled');
    carouselGlideElement.querySelector('.carousel__next').removeAttribute('disabled');
  };
  var disablePrevButton = function disablePrevButton() {
    carouselGlideElement.querySelector('.carousel__prev').classList.add('disabled');
    carouselGlideElement.querySelector('.carousel__prev').setAttribute('disabled', true);
  };
  var disableNextButton = function disableNextButton() {
    carouselGlideElement.querySelector('.carousel__next').classList.add('disabled');
    carouselGlideElement.querySelector('.carousel__next').setAttribute('disabled', true);
  };
  var showPaginationByPage = function showPaginationByPage() {
    // Glide shows a pagination button for each item, and doesn't provide
    // an option to navigate whole pages at a time.
    // This function hides extra individual dots, so that only the first item of
    // each page is shown. (Based on the `perView` setting).
    var _getCurrentSettings = getCurrentSettings(),
      perView = _getCurrentSettings.perView;
    var paginationElements = carouselGlideElement.querySelectorAll(".glide-carousel__pagination button:not(:nth-child(".concat(perView, "n + 1))"));
    paginationElements.forEach(function (item) {
      item.classList.add('hidden');
    });
    if (carouselLoop && window.innerWidth > MOBILE_BREAKPOINT) {
      return;
    }
    // disabling prev button by default
    disablePrevButton();
  };
  var slideToNext = function slideToNext() {
    var maxPerView = getCurrentSettings().perView;
    carouselGlideElement.querySelector('.carousel__next').addEventListener('click', function (event) {
      var target = event.target;
      var activeDots = 0;
      carouselGlideElement.querySelectorAll('.glide-carousel__pagination > *').forEach(function (dot, index) {
        if (dot.getAttribute('class') === 'glide__bullet--active') {
          activeDots = index;
        }
      });
      var nextSlide = activeDots + maxPerView;
      if (carouselLoop && window.innerWidth > MOBILE_BREAKPOINT) {
        if (nextSlide >= slides.length) {
          glide.go("=0");
        } else {
          glide.go("=".concat(nextSlide));
        }
      } else {
        glide.go("=".concat(nextSlide));
        if (nextSlide + maxPerView >= slides.length) {
          target.closest('button').classList.add('disabled');
          target.closest('button').setAttribute('disabled', true);
        }
        enablePrevButton();
      }
    });
  };
  var slideToPrevious = function slideToPrevious() {
    var maxPerView = getCurrentSettings().perView;
    carouselGlideElement.querySelector('.carousel__prev').addEventListener('click', function (event) {
      var target = event.target;
      var activeDots = 0;
      carouselGlideElement.querySelectorAll('.glide-carousel__pagination > *').forEach(function (dot, index) {
        if (dot.getAttribute('class') === 'glide__bullet--active') {
          activeDots = index;
        }
      });
      var prevSlide = activeDots - maxPerView;
      if (carouselLoop && window.innerWidth > MOBILE_BREAKPOINT) {
        if (prevSlide < 0) {
          var lastslide = Math.floor(slides.length / maxPerView) * maxPerView;
          glide.go("=".concat(lastslide));
        } else {
          glide.go("=".concat(prevSlide));
        }
      } else {
        if (prevSlide >= 0) {
          glide.go("=".concat(prevSlide));
        }
        if (prevSlide - maxPerView < 0) {
          target.closest('button').classList.add('disabled');
          target.closest('button').setAttribute('disabled', true);
        }
        enableNextButton();
      }
    });
  };
  var enableNextPrev = function enableNextPrev() {
    var maxPerView = getCurrentSettings().perView;
    carouselGlideElement.querySelectorAll('.glide-carousel__pagination > *').forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        if (index > 0) {
          enablePrevButton();
        }
        if (index === 0) {
          enableNextButton();
          disablePrevButton();
        }
        if (index + maxPerView >= slides.length) {
          disableNextButton();
        }
        if (index + maxPerView < slides.length) {
          enableNextButton();
        }
      });
    });
  };
  var showHideNavigation = function showHideNavigation() {
    var maxPerView = getCurrentSettings().perView;
    var navigationElements = carouselGlideElement.querySelectorAll('[data-glide-dir]');
    if (!slides || slides.length <= maxPerView) {
      navigationElements.forEach(function (item) {
        return item.classList.add('hidden');
      });
      // eslint-disable-next-line no-param-reassign
      carouselGlideElement.querySelector('.carousel-navigation').style.display = 'none';
      return;
    }
    navigationElements.forEach(function (item) {
      return item.classList.remove('hidden');
    });
    showPaginationByPage();
    // added manual arrow next/previous button action
    slideToNext();
    slideToPrevious();
    enableNextPrev();
  };
  var createPagination = function createPagination() {
    var bulletContainer = document.createElement('div');
    bulletContainer.classList.add('glide-carousel__pagination');
    bulletContainer.dataset.glideEl = 'controls[nav]';
    slides.forEach(function (slide, index) {
      var button = document.createElement('button');
      button.dataset.glideDir = "=".concat(index);
      bulletContainer.appendChild(button);
    });
    carouselGlideElement.querySelector('.carousel-nav-wrapper').appendChild(bulletContainer);
    showHideNavigation();
  };
  createPagination();
  window.addEventListener('resize', (0, _lodash["default"])(function () {
    // Hide the navigation when we don't have more items than we can show on screen
    showHideNavigation();
  }, 250));
  glide = new _glide["default"](carouselGlideElement, _objectSpread({
    perView: 4,
    breakpoints: breakpointSettings,
    type: glideType4,
    swipeThreshold: isSwipe4,
    dragThreshold: isSwipe4
  }, options)).mount();
  return glide;
};
exports["default"] = _default;


// WEBPACK FOOTER //
// ./components/cwm-gallery-carousel/scripts/cwm-carousel-glide.js